"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumWeatherCondition = exports.customerUnitEnum = exports.customerCountryEnum = exports.languageEnum = exports.accountTypeEnum = void 0;
const app_platform_i18n_core_1 = require("@semios/app-platform-i18n-core");
const zod_1 = require("zod");
// TODO: a lot of these will live elsewhere eventually??
exports.accountTypeEnum = zod_1.z.enum(['CUSTOMER', 'EMPLOYEE', 'TESTER', 'DEMO', 'FREE']);
exports.languageEnum = zod_1.z.enum(app_platform_i18n_core_1.I18nCore.LANGUAGES);
exports.customerCountryEnum = zod_1.z.enum(['AU', 'CA', 'DE', 'ES', 'FR', 'IT', 'NL', 'US']);
exports.customerUnitEnum = zod_1.z.enum(['METRIC', 'IMPERIAL']);
var EnumWeatherCondition;
(function (EnumWeatherCondition) {
    EnumWeatherCondition["wi-cloudy"] = "wi-cloudy";
    EnumWeatherCondition["wi-day-cloudy"] = "wi-day-cloudy";
    EnumWeatherCondition["wi-day-fog"] = "wi-day-fog";
    EnumWeatherCondition["wi-day-hail"] = "wi-day-hail";
    EnumWeatherCondition["wi-day-haze"] = "wi-day-haze";
    EnumWeatherCondition["wi-day-rain"] = "wi-day-rain";
    EnumWeatherCondition["wi-day-snow"] = "wi-day-snow";
    EnumWeatherCondition["wi-day-sunny"] = "wi-day-sunny";
    EnumWeatherCondition["wi-day-thunderstorm"] = "wi-day-thunderstorm";
    EnumWeatherCondition["wi-day-windy"] = "wi-day-windy";
    EnumWeatherCondition["wi-fog"] = "wi-fog";
    EnumWeatherCondition["wi-hail"] = "wi-hail";
    EnumWeatherCondition["wi-hot"] = "wi-hot";
    EnumWeatherCondition["wi-hurricane"] = "wi-hurricane";
    EnumWeatherCondition["wi-na"] = "wi-na";
    EnumWeatherCondition["wi-night-clear"] = "wi-night-clear";
    EnumWeatherCondition["wi-night-cloudy"] = "wi-night-cloudy";
    EnumWeatherCondition["wi-night-showers"] = "wi-night-showers";
    EnumWeatherCondition["wi-night-snow"] = "wi-night-snow";
    EnumWeatherCondition["wi-night-thunderstorm"] = "wi-night-thunderstorm";
    EnumWeatherCondition["wi-rain"] = "wi-rain";
    EnumWeatherCondition["wi-rain-mix"] = "wi-rain-mix";
    EnumWeatherCondition["wi-sandstorm"] = "wi-sandstorm";
    EnumWeatherCondition["wi-showers"] = "wi-showers";
    EnumWeatherCondition["wi-sleet"] = "wi-sleet";
    EnumWeatherCondition["wi-smoke"] = "wi-smoke";
    EnumWeatherCondition["wi-snow"] = "wi-snow";
    EnumWeatherCondition["wi-snow-wind"] = "wi-snow-wind";
    EnumWeatherCondition["wi-snowflake-cold"] = "wi-snowflake-cold";
    EnumWeatherCondition["wi-sunrise"] = "wi-sunrise";
    EnumWeatherCondition["wi-sunset"] = "wi-sunset";
    EnumWeatherCondition["wi-thunderstorm"] = "wi-thunderstorm";
    EnumWeatherCondition["wi-tornado"] = "wi-tornado";
    EnumWeatherCondition["wi-windy"] = "wi-windy";
})(EnumWeatherCondition || (exports.EnumWeatherCondition = EnumWeatherCondition = {}));
//# sourceMappingURL=enums.js.map